import { useState } from "react";
import s from "./Reviews.module.scss";
import { img, imageSrcSet } from "../utils/cloudinaryImage";

const REVIEW_AVATAR_PRESET = {
  width: 112,
  height: 112,
  crop: "fill",
  gravity: "auto",
  quality: "auto",
};
const reviewAvatarImage =
  "v1782912075/ChatGPT_Image_2026%E5%B9%B47%E6%9C%881%E6%97%A5_22_20_01_1_qimn6n.png";

const reviews = [
  {
    image: reviewAvatarImage,
    name: "Yuki / Japan",
    showMore: true,
    text: "初めてのSUPで少し不安でしたが、優しく教えてくれて安心して楽しめました。海が本当に綺麗で、写真も動画も想像以上のクオリティでした。自分たちだけでは行けないような場所にも連れて行ってもらえて、宮古島で一番の思い出になりました。",
  },
  {
    image: reviewAvatarImage,
    name: "Emily / UK",
    text: "Such a beautiful experience in Miyako Island. The ocean was unreal, and the photos felt like they were from a movie. It was relaxing, fun, and very special.",
  },
  {
    image: reviewAvatarImage,
    name: "Liam / Australia",
    text: "The drone shots were incredible. We could never have captured these memories by ourselves. The whole tour felt private, cinematic, and perfectly organized.",
  },
  {
    image: reviewAvatarImage,
    name: "Emma / Canada",
    text: "The hidden beach was absolutely stunning. Everything was calm, beautiful, and premium. I loved that we could just enjoy the moment while the photos were taken for us.",
  },
  {
    image: reviewAvatarImage,
    name: "Mika / Japan",
    text: "サンセットの時間に撮ってもらった写真が本当にお気に入りです。普通の観光では残せないような雰囲気で、宮古島旅行が特別な思い出になりました。",
  },
  {
    image: reviewAvatarImage,
    name: "Noah / USA",
    text: "Amazing guide, beautiful locations, and the drone footage was next level. This was one of the highlights of our trip to Miyako Island.",
  },
  {
    image: reviewAvatarImage,
    name: "Sora / Japan",
    text: "写真も動画も全部おしゃれで、友達にもめちゃくちゃ褒められました。宮古島で特別な思い出を残したい人には本当におすすめです。",
  },
];

const ReviewAvatar = ({ src, alt, priority = false }) => {
  return (
    <img
      src={img(src, REVIEW_AVATAR_PRESET)}
      srcSet={imageSrcSet(src, REVIEW_AVATAR_PRESET, [56, 112, 168])}
      sizes="56px"
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "low"}
      decoding="async"
      width="56"
      height="56"
    />
  );
};

const Reviews = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className={s.root}>
      <div className={`${s.reviewList} ${reviews.length > 6 ? s.scroll : ""}`}>
        {reviews.map((review, index) => {
          const isOpen = open === review.name;
          const hasMore = review.showMore === true;

          return (
            <article
              className={`${s.card} ${isOpen ? s.open : ""}`}
              key={review.name}
            >
              <div className={s.cardTop}>
                <ReviewAvatar
                  src={review.image}
                  alt={review.name}
                  priority={index === 0}
                />

                <div>
                  <p className={s.stars}>★★★★★</p>
                  <p className={s.name}>{review.name}</p>
                </div>
              </div>

              <p
                className={`${s.comment} ${hasMore && !isOpen ? s.clamp : ""}`}
              >
                {review.text}
              </p>

              {hasMore && (
                <button
                  type="button"
                  className={s.moreBtn}
                  onClick={() => setOpen(isOpen ? null : review.name)}
                >
                  {isOpen ? "閉じる" : "もっと読む"}
                </button>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Reviews;
